<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center" data-aos="fade-down">
                <h1 class="">Who are we?</h1>
                <p class="">This is who we are and value we stand for</p>
            </div>
        </div>
    </section>

    <!-- coralstone -->
    <section class="coralstone">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
              <div class="coralstone-header" data-aos="fade-up">
                  <h3>We are Coralstone Capital</h3>
              </div>
          </div>
          <div class="col-md-6">
            <div class="coralstone-text" data-aos="fade-up">
                  <p>Coralstone Capital Limited is a group of companies that exist to power the dreams of everyday people by providing them with premium financial services tailored to suit their financial needs.</p>
                  <p>From low-interest loans to high-yield investments, asset management, and financial advisory, we take your side and protect your financial interest.</p>
                  <p>We deploy the finest combination of financial expertise, advanced technology and professional service to help you plan, manage, and build sustainable wealth.</p>
                  <p>Our clients love us because we demystify money management and give them fast and easy access to high-value financial services while guiding them to a future of financial security.</p>
              </div>
          </div>
        </div>
      </div>
    </section>

    <!-- mission -->
    <section class="mission">
      <div class="container">
        <div class="row">
          <div class="col-md-6 order-1 order-md-1">
              <div class="mission-text" data-aos="fade-up">
                  <h3>Our Mission</h3>
                  <p>To help our clients create a financially secure future by providing them with quality financial services and high-yield investment products that will enable them to build and preserve wealth.</p>
              </div>
          </div>
          <div class="col-md-6 order-md-2">
            <div class="mission-image-wrapper" data-aos="fade-up">
                <img src="/img/mission.svg" alt="" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </section>

     <!-- vision -->
    <section class="vision">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="vision-image-wrapper" data-aos="fade-up">
                <img src="/img/vision.svg" alt="" class="img-fluid">
            </div>
          </div>
          <div class="col-md-6">
            <div class="vision-text" data-aos="fade-up">
                <h3>Our Vision</h3>
                <p>To be recognised as a leading financial services and investment management company in the marketplace, having built an unmatched reputation for innovative and convenient financial solutions, profitability, and strong customer relationships.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- leadership section -->
    <div class="overlay" id="overlay"></div>
    <section class="leadership d-none">
      <div class="container">
          <h3 data-aos="fade-up">Leadership</h3>
          <div class="row">
            <div class="col-lg-6">
              <div class="row" data-aos="fade-up">
                <div class="col-6">
                  <a href="#" data-toggle="modal" data-target="#role">
                  <div class="card">
                    <img src="/img/leadership/leadership1.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Judith Lane</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                  </a>
                </div>
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership2.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Eleanor Cooper</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row" data-aos="fade-up">
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership3.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Victoria Cooper</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership4.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Eleanor Cooper</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
      </div>
      <AboutPopup />
    </section>

    <!-- Board Member section -->
    <section class="board-member d-none">
      <div class="container">
          <h3 data-aos="fade-up">Board Members</h3>
          <div class="row">
            <div class="col-lg-6">
              <div class="row" data-aos="fade-up">
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership1.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Judith Lane</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership2.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Eleanor Cooper</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row" data-aos="fade-up">
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership3.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Victoria Cooper</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="card">
                    <img src="/img/leadership/leadership4.svg" class="card-img-top" alt="">
                    <div class="card-body">
                      <h5 class="card-title">Eleanor Cooper</h5>
                      <p class="card-text">Designation</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
      </div>
      
    </section >

    <!-- Part of us -->
    <section class="part-action">
      <div class="container">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <div class="description text-center" data-aos="zoom-in">
                <h3>Want to be part of us?</h3>
                <p>Are you a good fit for Coralstone Capital and have what it takes to help us reach our goal</p>
                <a @click="$router.push({ name: 'Careers'})" href="#" class="btn btn-primary px-5">Join Us</a>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";
import AboutPopup from "../components/AboutPopup";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer,
    AboutPopup
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/about-hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
      }
  }

  // coralstone styles
  h3 {
    font-weight: bold;
    font-size: 36px;
    line-height: 72px;
    letter-spacing: 0.02em;
    color: map-get($colors, deep-blue);
  }
  .coralstone {
    margin-top: -12rem;
    padding-bottom: 8rem;

    .coralstone-header {
      
      background: #FFFFFF;
      border-radius: 8px;
      padding: 3rem 0 3rem 3rem;
    
      h3 {
        font-style: normal;
        font-weight: bold;
        font-size: 57px;
        line-height: 100%;
        color: #2C3C90;
      }
    }

    .coralstone-text {

      height: 100%;
      // display: flex;
      // align-items: flex-end;
      padding-left: 3rem;
      padding-top: 7rem;

       p {
        font-family: Poppins;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 27px;
        color: #2C3C90;
      }
    }
  }

  // mission
  .mission {
    padding-bottom: 6rem;
    
    .mission-text, .vision-text {
      padding-top: 4rem;

      p { 
        color: #2C3C90;
        font-family: Poppins;
        font-size: 20px;
      }
    }
  }

  // vision 
  .vision {
    padding-bottom: 6rem;

    .vision-text {
      padding-left: 3rem;
      padding-top: 2rem;

      p { 
        color: #2C3C90;
        font-family: Poppins;
        font-size: 20px;
      }
    }
  }

  // .overlay {
  //     background: rgba(0, 0, 0, 0.5);
  //     position: absolute;
  //     width: 100%;
  //     height: 100vh;
  //     z-index: 20000;
  // }

   .leadership, .board-member {
    padding: 4rem 0;
   }

  // leadership
  .leadership {
    background: linear-gradient(180deg, #94248C 0%, #2C3C90 100%);
    padding: 4rem 0;
    position: relative;

    a {
      text-decoration: none;
    }

    .card {

      background-color: transparent;
      border-color: transparent;
      margin-bottom: 2.5rem;

      .card-body {
        padding: 0;

        h5 {
          font-family: 'Poppins', sans-serif;
          font-weight: bold;
          font-size: 17px;
          line-height: 33px;
          letter-spacing: 0.02em;
        }

        .card-title {
          margin-bottom: 0;
        }

        .card-text {
          color: #F1F3F4;
        }


        p {
          font-family: 'Poppins', sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          letter-spacing: 0.02em;
        }

        p {
          color: #666670;
        }

        a {
          font-weight: 500;
        }
      }
    }

     h3, .card-title {
      color: #fff;
    }
  }

  // board-member
  .board-member {

    .card {

      background-color: transparent;
      border-color: transparent;
      margin-bottom: 2.5rem;

      .card-body {
        padding: 0;

        h5 {
          font-family: 'Poppins', sans-serif;
          font-weight: bold;
          font-size: 17px;
          line-height: 33px;
          letter-spacing: 0.02em;
        }

        .card-title {
          margin-bottom: 0;
        }

        .card-text {
          color: #666670
        }


        p {
          font-family: 'Poppins', sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 19px;
          letter-spacing: 0.02em;
        }

        p {
          color: #666670;
        }

        a {
          font-weight: 500;
        }
      }
    }

     h3 {
       color: #2C3C90;
     }
     .card-title {
      color: #171F4A;;
    }
  }

  // call to action
  .part-action {
    padding-bottom: 6rem;

    .description {
      p {
        font-family: Poppins;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #2C3C90;
      }

      .btn {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.02em;
        text-transform: capitalize;
      }
    }
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 64px;
                line-height: 96px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }

    h3 {
      font-size: 36px;
    }
  }


  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 52px;
                line-height: 76px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 5rem;
            }
        }
    }

    // coralstone styles
  h3 {
    font-size: 28px;
    
  }
  .coralstone {
    margin-top: -12rem;
    padding-bottom: 6rem;

    .coralstone-header {
      padding: 4rem 2rem 3rem ;
    
      h3 {
        font-size: 46px;
      }
    }

    .coralstone-text {

      padding-left: 3rem;
      padding-top: 4rem;

       p {
        font-size: 16px;
      }
    }
  }
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 42px;
                line-height: 57px;
            }

            p {
                font-size: 20px;
                line-height: 32px;
                padding: 0 3rem;
            }
        }
    }

    h3 {
      font-size: 28px;
      text-align: left;
    }

    .coralstone {
      margin-top: -16rem;
      padding-bottom: 5rem;

      .coralstone-header {
        padding: 3rem ;
      
        h3 {
          font-size: 40px;
          text-align: left !important;
        }
      }

      .coralstone-text {

        padding: 0 3rem 3rem;
        background: #FFFFFF;
        border-radius: 0 0 8px 8px;

        p:first-child {
          margin-top: -2rem;
        }

        p {
          font-size: 18px;
        }
      }
    }

      // mission
    .mission {
      padding-bottom: 6rem;

      .mission-image-wrapper {
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
      }
      
      .mission-text, .vision-text {
        padding: 1rem 2rem 2rem;
        background: #FFFFFF;
        border-radius: 0 0 8px 8px;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
      }
    }

    // vision 
    .vision {
      padding-bottom: 6rem;

      .vision-image-wrapper {
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
      }

      .vision-text {
        padding: 1rem 2rem 2rem;
        background: #FFFFFF;
        border-radius: 0 0 8px 8px;
        box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
      }
    }

    .part-action {

      .description {
        h3 {
          text-align: center;
        }
      }
    }
  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        

        .description {

            h1 {
                line-height: 46px;
            }

        }
    }

    .mission, .vision {
    
    .mission-text, .vision-text {

      p { 
        font-size: 18px;
      }
    }
  }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    h3 {
      font-size: 24px;
    }

    .coralstone {

      .coralstone-header {
        padding: 2rem ;
      
        h3 {
          font-size: 36px;
        }
      }

      .coralstone-text {

        padding: 0 2rem 2rem;
       

        p:first-child {
          margin-top: -2rem;
        }
      }
    }

    // leadership
  .leadership {
    padding: 1rem 0 2rem;

    .card {

      .card-body {

        h5 {
          font-size: 15px;
        }

        p {
          font-size: 13px;
        }

      }
    }
  }

  // board-member
  .board-member {
    padding: 1rem 0 2rem;

    .card {

      .card-body {

        h5 {
          font-size: 15px;
        }

        p {
          font-size: 13px;
        }
      }
    }
  }

  .part-action {

      .description {
        h3 {
          padding: 0 2rem;
          line-height: 33px;
        }
      }
    }
    
  }


</style>

